import { ProductName } from 'domain/product/enums/ProductName';
import { FunctionComponent, ReactNode, createContext, useContext } from 'react';

export type ProductContextType = {
	productName: ProductName;
};

export const ProductContext = createContext<ProductContextType | null>(null);

const ProductContextProvider: FunctionComponent<{
	productName: ProductName;
	children: ReactNode;
}> = ({ productName, children }) => (
	<ProductContext.Provider
		value={{
			productName,
		}}
	>
		{children}
	</ProductContext.Provider>
);

export function useProductContext() {
	const context = useContext(ProductContext);
	if (!context) {
		throw new Error(
			'useProductContext must be used within the ProductContextProvider',
		);
	}
	return context;
}

export default ProductContextProvider;
